export const StatusTypes = {
  NEW: 'NEW',
  INCOMPLETE: 'INCOMPLETE',
  SUBMITTED: 'SUBMITTED',
  SUBMITTED_SYNC_SUCCESS: 'SUBMITTED_SYNC_SUCCESS',
  SUBMITTED_SYNC_FAILED: 'SUBMITTED_SYNC_FAILED'
};

export const EventTypes = {
  TEXT_FIELD_TYPING: 'TEXT_FIELD_TYPING',
  VALUE_CHANGE: 'VALUE_CHANGE',
  ACCESS_ASSESSMENT: 'ACCESS_ASSESSMENT',
  ASSESSMENT_STATUS_CHANGE: 'ASSESSMENT_STATUS_CHANGE',
  DDE_ACTIONS_TRIGGERED: 'DDE_ACTIONS_TRIGGERED'
};

export const TemplateEventTypes = {
  TEMPLATE_TEXT_FIELD_TYPING: 'TEMPLATE_TEXT_FIELD_TYPING',
  TEMPLATE_VALUE_CHANGE: 'TEMPLATE_VALUE_CHANGE',
  ACCESS_TEMPLATE: 'ACCESS_TEMPLATE',
  TEMPLATE_STATUS_CHANGE: 'TEMPLATE_STATUS_CHANGE'
};

export const EventEmitterTypes = {
  TOGGLE_MOBILE_SIDEBAR: 'TOGGLE_MOBILE_SIDEBAR',
  TOGGLE_ADD_PARTICIPANTS: 'TOGGLE_ADD_PARTICIPANTS',
  SCROLL_INTO_VIEW: 'SCROLL_INTO_VIEW',
  TOGGLE_VISIBLE_CATEGORY: 'TOGGLE_VISIBLE_CATEGORY',
  SHOW_LOADER: 'SHOW_LOADER'
};

export const SidebarViews = Object.freeze({
  SECTIONS: 'SECTIONS',
  FILTERS: 'FILTERS',
  PARTICIPANT_DETAILS: 'PARTICIPANT_DETAILS',
  OVERVIEW: 'OVERVIEW'
});

export const DeviceWidth = {
  MOBILE: 836
};

export const SIDEBAR_TOGGLE_DURATION = 3100;

export default {
  StatusTypes,
  EventTypes,
  SidebarViews,
  DeviceWidth
};
